import AddTaxRate from "../../components/organisms/softpos/AddTaxRate";
import { AdminTemplate } from "../../components";

export const AddTaxRatePage = () => {

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Yeni Vergi Oranı Ekleme",
        hideAddButton: true,
      }}
    >
      <AddTaxRate />
    </AdminTemplate>
  );
};
